import { fillWithZero } from 'civil-status/utils/fill-zero';
import PmiTextField, { PmiTextFieldProps } from 'shell/components/shared/text-field';

type NumberActTextFieldProps = Omit<PmiTextFieldProps, 'onBlur'> & {
  onBlur?: (value?: string) => void;
};

const NumberAct: React.FC<NumberActTextFieldProps> = (
  props: NumberActTextFieldProps
): React.ReactElement => {
  const onBlur = () => {
    // event?.preventDefault();
    // event?.stopPropagation();
    if (props.value && (props.value as string)?.toString()?.length < props.inputProps?.maxLength) {
      if (props.onBlur) {
        props.onBlur(
          fillWithZero((props.value as string)?.toString() || '', props.inputProps?.maxLength || 0)
        );
      }
    }

    return;
  };

  return <PmiTextField {...props} onBlur={onBlur} />;
};

NumberAct.displayName = 'Number act component';

export default NumberAct;
